import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/card';
import { Loader2, ScrollText } from 'lucide-react';
import { contentAPI, mediaUrl } from '../services/api';

export default function Reglement() {
  const [data, setData] = useState(null);
  useEffect(() => { contentAPI.reglement().then(setData).catch(() => setData({ text: '', images: [] })); }, []);

  if (!data) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-red-600" /></div>;

  const empty = !data.text && (!data.images || data.images.length === 0);

  return (
    <div className="space-y-5 animate-rise max-w-2xl mx-auto">
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-red-950 dark:text-red-50 flex items-center gap-2"><ScrollText className="w-7 h-7 text-red-600" />Règlement</h1>
        <p className="text-muted-foreground text-sm mt-1">Les règles du Body Fit Challenge 21</p>
      </div>

      {empty ? (
        <Card className="p-10 rounded-2xl border-red-100 dark:border-red-900/50 text-center">
          <p className="text-sm text-muted-foreground">Le règlement sera bientôt disponible.</p>
        </Card>
      ) : (
        <Card className="p-6 rounded-2xl border-red-100 dark:border-red-900/50" data-testid="reglement-content">
          {data.text && <p className="text-sm text-foreground whitespace-pre-wrap leading-relaxed">{data.text}</p>}
          {data.images?.length > 0 && (
            <div className="mt-4 space-y-3">
              {data.images.map((img, i) => (
                <img key={i} src={mediaUrl(img)} alt="" className="w-full rounded-xl" />
              ))}
            </div>
          )}
        </Card>
      )}

      <p className="text-[11px] text-muted-foreground text-center leading-relaxed px-4">
        Ce challenge est un programme d'accompagnement bien-être. Il ne remplace pas un avis médical.
      </p>
    </div>
  );
}
